import { Box, Flexbox, Icon, Tooltip, Typography } from '@hiiretail/synergy-ui';
import { Status } from '../../../../common/components/Status/Status';
import styled from 'styled-components';
import { CopyToClipboard } from '../../../../common/components/CopyToClipboard/CopyToClipboard';
import { UserDto } from '../../../../api-client';
import React from 'react';

const InfoCard = styled(Flexbox)`
  background: white;
  border-radius: 8px;
  padding: 32px;
`;

const StyledTypography = styled(Typography)`
  margin: 0;
`;

const InfoBox = styled(Flexbox)`
  background-color: #7f7f7f33;
  padding: ${({ theme }) => theme.spacing(1)}px ${({ theme }) => theme.spacing(2)}px;
  border-radius: 4px;
  cursor: default !important;

  span {
    display: flex;
    align-items: center;
  }
`;

type UserInfoProps = {
  user: UserDto;
};

type UserInfoComponent = React.FC<UserInfoProps>;

export const UserInfo: UserInfoComponent = ({ user }) => {
  return (
    <InfoCard container direction="column" gutter={2}>
      <Flexbox container item alignItems="center" justifyContent="space-between" flex="1 1 auto">
        <Flexbox container alignItems="center" gutter={2}>
          <Flexbox item>
            <Icon.Person bold />
          </Flexbox>
          <Flexbox item>
            <StyledTypography variant="header3">{user.name}</StyledTypography>
          </Flexbox>
        </Flexbox>
        <Status status={user.status} variant="body2" />
      </Flexbox>
      <Flexbox container gutter={2}>
        <InfoBox item>
          <Tooltip
            title={
              <Flexbox container direction="column" style={{ maxWidth: '30vw', color: 'white' }}>
                <Typography variant="body2" weight="bold">
                  Staff
                </Typography>
                <Typography variant="caption">
                  Staff user represents tenant's employee. This type of user can perform some
                  administrative work for the tenant if given the right permissions. Staff users can
                  log in at tenant-alias.hiiretail.com
                </Typography>
                <Box mt={1} />
                <Typography variant="body2" weight="bold">
                  Shoppers
                </Typography>
                <Typography variant="caption">
                  A customer of a tenant. And is a user of other applications (Scan & Go, Click &
                  Collect, etc.).
                </Typography>
              </Flexbox>
            }
          >
            <Flexbox container alignItems="center" gutter={1}>
              <Flexbox item container alignItems="center" gutter={1}>
                <Flexbox item>
                  <Typography variant="body2">Scope:</Typography>
                </Flexbox>
                <Flexbox item>
                  <Typography variant="body2" weight="bold">
                    {user.scope}
                  </Typography>
                </Flexbox>
              </Flexbox>
              <Flexbox item>
                <Icon.QuestionmarkRound size="sm" bold />
              </Flexbox>
            </Flexbox>
          </Tooltip>
        </InfoBox>
        <InfoBox item>
          <Tooltip
            title={
              <Flexbox container direction="column" style={{ maxWidth: '30vw', color: 'white' }}>
                <Typography variant="body2" weight="bold">
                  Standalone
                </Typography>
                <Typography variant="caption">
                  Standalone users are created within Hii Retail.
                </Typography>
                <Box mb={1} />
                <Typography variant="body2" weight="bold">
                  Federated
                </Typography>
                <Typography variant="caption">
                  Federated users are created in a third party identity system (Google, Okta, Azure
                  AD). Their data is not stored in Hii Retail, but imported from the system where
                  they created.
                </Typography>
              </Flexbox>
            }
          >
            <Flexbox container alignItems="center" gutter={1}>
              <Flexbox item container alignItems="center" gutter={1}>
                <Flexbox item>
                  <Typography variant="body2">Type:</Typography>
                </Flexbox>
                <Flexbox item>
                  <Typography variant="body2" weight="bold">
                    {user.type}
                  </Typography>
                </Flexbox>
              </Flexbox>
              <Flexbox item>
                <Icon.QuestionmarkRound size="sm" bold />
              </Flexbox>
            </Flexbox>
          </Tooltip>
        </InfoBox>
        <InfoBox item>
          <Flexbox container alignItems="center" gutter={1}>
            <Flexbox item container alignItems="center" gutter={1}>
              <Flexbox item>
                <Typography variant="body2">Identifier:</Typography>
              </Flexbox>
              <Flexbox item>
                <CopyToClipboard text={user.id} variant="body2" weight="bold" />
              </Flexbox>
            </Flexbox>
          </Flexbox>
        </InfoBox>
      </Flexbox>
    </InfoCard>
  );
};
